module.exports = __webpack_public_path__ + "static/media/welcome.729fbd7f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/welcome.svg
 ** module id = 784
 ** module chunks = 0
 **/